
<div class="add-section">
  <form class="add-section__form" [formGroup]="addSectionForm" novalidate="novalidate" autocomplete="off">
    <div class="add-section__fieldset">
      <div class="row add-section__fields">
        <div class="columns small-12 small-centered">
          <div class="form__field--lower add-section__field" [class.form__field--error]="isFieldInvalid(addSectionForm.controls['name'])">
            <label class="label add-section__field-label">{{ 'ADMIN_SETTINGS.REFERENCE_DOCUMENTS.ADD_SECTION_MODAL.FORM.LABEL.NAME' | translate }}</label>
            <div class="form-field__error">{{ 'ADMIN_SETTINGS.REFERENCE_DOCUMENTS.ADD_SECTION_MODAL.FORM.ERROR.NAME_EMPTY' | translate }}</div>
            <input class="input" placeholder="{{ 'ADMIN_SETTINGS.REFERENCE_DOCUMENTS.ADD_SECTION_MODAL.FORM.PLACEHOLDER.NAME' | translate }}" type="text" name="name" [formControl]="addSectionForm.controls['name']"/>
          </div>
          <div class="form__field--lower add-section__field">
            <label class="label add-section__field-label">
              <gw-check-box class="add-section__check-box" [(ngModel)]="addAnother" [ngModelOptions]="{standalone: true}"></gw-check-box><span class="link add-section__check-box-label">{{ 'ADMIN_SETTINGS.REFERENCE_DOCUMENTS.ADD_SECTION_MODAL.FORM.LABEL.ADD_ANOTHER' | translate }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>